import React, { useState, useEffect, useCallback } from "react";
import URLManager from "../funcionalidadeNavbar/URLManager";

import { Button, Snackbar, Checkbox, FormControlLabel, Box, TextField, Modal, Typography} from "@mui/material";
import PermissionGate from "./PermissionGate";
import CadastrarPerfilTabela from "./CadastrarPerfilTabela";
import CadastrarPerfilFormulario from "./CadastrarPerfilFormulario";

// Estilo para o modal
const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    maxWidth: '800px',
    maxHeight: '80vh',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    overflowY: 'auto'
};

const CadastrarPerfil = () => {
    const _url = URLManager.getBaseURL();

    const cadastrarPerfil = {
        id: 0,
        nome: '',
        permissoes: {

            materiaPrimaCadastrar: false,
            materiaPrimaAlterar: false,
            materiaPrimaRemover: false,
            materiaPrimaAtivar: false,
            materiaPrimaInativar: false,
            materiaPrimaListar: false,
            fornecedorAlterar: false,
            fornecedorRemover: false,
            fornecedorCadastrar: false,
            produtoCadastrar: false,
            produtoAlterar: false,
            produtoRemover: false,
            fichaTecnicaItensCopiarItens: false,
            fichaTecnicaItensCadastrar: false,
            fichaTecnicaItensAlterar: false,
            fichaTecnicaItensRemover: false,
            fichaTecnicaCadastra: false,
            listarPerfis: false,
            cadastrarPerfil: false,
            cadastrarUsuarios: false,
            cadastrarTesteCalce: false,
            listarPorProduto: false,
            buscarPorId: false,
            listarTodos: false,
            triggerNotificacoes: false,
            removerTeste: false,
        }
    };

    // Estados
    const [popperMessage, setPopperMessage] = useState('');

    const [permissoesPorCategoria, setPermissoesPorCategoria] = useState({});
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [modalPerfil, setModalPerfil] = useState(cadastrarPerfil);
    const [loading, setLoading] = useState({
        perfis: true,
        permissoes: false,
        salvando: false
    });
    const [error, setError] = useState(null);
    const [perfis, setPerfis] = useState([]);


    // Funções auxiliares
    const mostrarMensagem = (mensagem) => {
        setPopperMessage(mensagem);
        setSnackbarOpen(true);
        setTimeout(() => setSnackbarOpen(false), 3000);
    };

    const handleOpenModal = () => {
        setModalPerfil(cadastrarPerfil);
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const handleModalChange = (e) => {
        setModalPerfil({ ...modalPerfil, [e.target.name]: e.target.value });
    };

    const handleModalPermissaoChange = (permissaoNome) => (e) => {
        const isChecked = e.target.checked;
        setModalPerfil(prev => ({
            ...prev,
            permissoes: {
                ...prev.permissoes,
                [permissaoNome]: isChecked
            }
        }));
    };

    const salvarPerfilModal = () => {
    setLoading({ ...loading, salvando: true });
    const token = sessionStorage.getItem("usuarioToken");
    
    // Obter dados do usuário logado
    fetch(`${_url}/user/dados`, {
        headers: { Authorization: `Bearer ${token}` }
    })
    .then(res => {
        if (!res.ok) throw new Error(`Erro HTTP! status: ${res.status}`);
        return res.json();
    })
    .then(userData => {
        if (!userData?.idEmpresa) {
            throw new Error("Usuário não está associado a uma empresa");
        }

        // Criar objeto com todos os dados necessários
        const perfilData = {
            nome: modalPerfil.nome,
            idEmpresa: userData.idEmpresa, // Garantir que está passando o ID correto
            ...modalPerfil.permissoes
        };

        return fetch(`${_url}/perfil/criarPerfil`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(perfilData)
        });
    })
    .then(res => {
        if (!res.ok) throw new Error(`Erro HTTP! status: ${res.status}`);
        return res.json();
    })
    .then(retorno => {
        mostrarMensagem('Perfil cadastrado com sucesso!');
        setOpenModal(false);
        carregarPerfis();
    })
    .catch(erro => {
        console.error("Erro:", erro);
        mostrarMensagem(erro.message || 'Erro ao cadastrar perfil');
    })
    .finally(() => setLoading({ ...loading, salvando: false }));
};

    // Carregar dados
    const carregarPerfis = useCallback(() => {
        setLoading(prev => ({...prev, perfis: true}));
        setPerfis([]); // Limpa a lista antes de recarregar
        fetch(`${_url}/perfil/listar`, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${sessionStorage.getItem("usuarioToken")}`
            },
        })
            .then((res) => res.json())
            .then((perfis) => setPerfis(perfis))
            .catch((erro) => setError(erro.message))
            .finally(() => setLoading(prev => ({...prev, perfis: false})));
    }, [_url]);

    const carregarTodasPermissoes = useCallback(() => {
        setLoading(prev => ({...prev, permissoes: true}));
        fetch(`${_url}/permissao/listar`, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${sessionStorage.getItem("usuarioToken")}`
            },
        })
            .then((res) => res.json())
            .then((permissoes) => {
                const agrupadas = permissoes.reduce((acc, permissao) => {
                    if (!acc[permissao.categoria]) acc[permissao.categoria] = [];
                    acc[permissao.categoria].push(permissao);
                    return acc;
                }, {});
                setPermissoesPorCategoria(agrupadas);
            })
            .catch((erro) => setError(erro.message))
            .finally(() => setLoading(prev => ({...prev, permissoes: false})));
    }, [_url]);

    useEffect(() => {
        carregarPerfis();
        carregarTodasPermissoes();
    }, [carregarPerfis, carregarTodasPermissoes]);

    const buscarPerfilPorId = async (id) => {
        try {
            setLoading({ ...loading, permissoes: true });

            const response = await fetch(`${_url}/perfil/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${sessionStorage.getItem("usuarioToken")}`
                },
            });

            if (!response.ok) {
                throw new Error('Perfil não encontrado');
            }

            const perfilDTO = await response.json();
            console.log('Perfil retornado:', perfilDTO); // <-- Adicione esta linha
            return perfilDTO;

        } catch (error) {
            console.error('Erro ao buscar perfil:', error);
            mostrarMensagem(error.message || 'Erro ao buscar perfil');
            return null;
        } finally {
            setLoading({ ...loading, permissoes: false });
        }
    };

    const editar = async (id) => {
        const perfilDTO = await buscarPerfilPorId(id);

        if (!perfilDTO) return;

        // Cria o objeto no formato que seu componente espera
        setModalPerfil({
            id: perfilDTO.id,
            nome: perfilDTO.nome,
            permissoes: {
                materiaPrimaCadastrar: perfilDTO.materiaPrimaCadastrar || false,
                materiaPrimaAlterar: perfilDTO.materiaPrimaAlterar || false,
                materiaPrimaRemover: perfilDTO.materiaPrimaRemover || false,
                materiaPrimaAtivar: perfilDTO.materiaPrimaAtivar || false,
                materiaPrimaInativar: perfilDTO.materiaPrimaInativar || false,
                materiaPrimaListar: perfilDTO.materiaPrimaListar || false,
                fornecedorAlterar: perfilDTO.fornecedorAlterar || false,
                fornecedorRemover: perfilDTO.fornecedorRemover || false,
                fornecedorCadastrar: perfilDTO.fornecedorCadastrar || false,
                produtoCadastrar: perfilDTO.produtoCadastrar || false,
                produtoAlterar: perfilDTO.produtoAlterar || false,
                produtoRemover: perfilDTO.produtoRemover || false,
                fichaTecnicaItensCopiarItens: perfilDTO.fichaTecnicaItensCopiarItens || false,
                fichaTecnicaItensCadastrar: perfilDTO.fichaTecnicaItensCadastrar || false,
                fichaTecnicaItensAlterar: perfilDTO.fichaTecnicaItensAlterar || false,
                fichaTecnicaItensRemover: perfilDTO.fichaTecnicaItensRemover || false,
                fichaTecnicaCadastra: perfilDTO.fichaTecnicaCadastra || false,
                listarPerfis: perfilDTO.listarPerfis || false,
                cadastrarPerfil: perfilDTO.cadastrarPerfil || false,
                cadastrarUsuarios: perfilDTO.cadastrarUsuarios || false,
                cadastrarTesteCalce: perfilDTO.cadastrarTesteCalce|| false,
                listarPorProduto: perfilDTO.listarPorProduto || false,
                buscarPorId: perfilDTO.buscarPorId || false,
                listarTodos: perfilDTO.listarTodos || false,
                triggerNotificacoes: perfilDTO.triggerNotificacoes || false,
                removerTeste: perfilDTO.removerTeste || false,
            }
        });

        setOpenModal(true);
    };

    const alterarPerfilModal = async () => {
        setLoading({ ...loading, salvando: true });
    
        try {
            // Prepara os dados no formato que o backend espera
            const dadosParaEnviar = {
                id: modalPerfil.id, // Inclui o ID do perfil
                nome: modalPerfil.nome,
                // Inclui todas as permissões explicitamente
                materiaPrimaCadastrar: modalPerfil.permissoes.materiaPrimaCadastrar || false,
                materiaPrimaAlterar: modalPerfil.permissoes.materiaPrimaAlterar || false,
                materiaPrimaRemover: modalPerfil.permissoes.materiaPrimaRemover || false,
                materiaPrimaAtivar: modalPerfil.permissoes.materiaPrimaAtivar || false,
                materiaPrimaInativar: modalPerfil.permissoes.materiaPrimaInativar || false,
                materiaPrimaListar: modalPerfil.permissoes.materiaPrimaListar || false,
                fornecedorAlterar: modalPerfil.permissoes.fornecedorAlterar || false,
                fornecedorRemover: modalPerfil.permissoes.fornecedorRemover || false,
                fornecedorCadastrar: modalPerfil.permissoes.fornecedorCadastrar || false,
                produtoCadastrar: modalPerfil.permissoes.produtoCadastrar || false,
                produtoAlterar: modalPerfil.permissoes.produtoAlterar || false,
                produtoRemover: modalPerfil.permissoes.produtoRemover || false,
                fichaTecnicaItensCopiarItens: modalPerfil.permissoes.fichaTecnicaItensCopiarItens || false,
                fichaTecnicaItensCadastrar: modalPerfil.permissoes.fichaTecnicaItensCadastrar || false,
                fichaTecnicaItensAlterar: modalPerfil.permissoes.fichaTecnicaItensAlterar || false,
                fichaTecnicaItensRemover: modalPerfil.permissoes.fichaTecnicaItensRemover || false,
                fichaTecnicaCadastra: modalPerfil.permissoes.fichaTecnicaCadastra || false,
                listarPerfis: modalPerfil.permissoes.listarPerfis || false,
                cadastrarPerfil: modalPerfil.permissoes.cadastrarPerfil || false,
                cadastrarUsuarios: modalPerfil.permissoes.cadastrarUsuarios || false,
                cadastrarTesteCalce: modalPerfil.permissoes.cadastrarTesteCalce|| false,
                listarPorProduto: modalPerfil.permissoes.listarPorProduto || false,
                buscarPorId: modalPerfil.permissoes.buscarPorId || false,
                listarTodos: modalPerfil.permissoes.listarTodos || false,
                triggerNotificacoes: modalPerfil.permissoes.triggerNotificacoes || false,
                removerTeste: modalPerfil.permissoes.removerTeste || false,
            };
    
            console.log('Dados enviados:', dadosParaEnviar); // Para debug
    
            const response = await fetch(`${_url}/perfil/alterar/${modalPerfil.id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sessionStorage.getItem("usuarioToken")}`
                },
                body: JSON.stringify(dadosParaEnviar)
            });
    
            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(errorText || 'Erro ao atualizar perfil');
            }
    
            const retorno = await response.json();
            mostrarMensagem(retorno.mensagem || 'Perfil atualizado com sucesso!');
            handleCloseModal();
            carregarPerfis();
        } catch (error) {
            console.error('Erro na atualização:', error);
            mostrarMensagem(error.message || 'Erro ao atualizar perfil');
        } finally {
            setLoading({ ...loading, salvando: false });
        }
    };

    const removerPerfilModal = async () => {
       
            setLoading({ ...loading, salvando: true });
            
            fetch(`${_url}/perfil/remover/${modalPerfil.id}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${sessionStorage.getItem("usuarioToken")}`
                },
            })
    
                .then((retorno) => retorno)
                .then((retorno_convertido) => {
                    mostrarMensagem(retorno_convertido.mensagem);
                    let vetorTemp = [...perfis];
                    let indice = vetorTemp.findIndex((p) => p.id === modalPerfil.id);
                    vetorTemp.splice(indice,1);
                    setPerfis(vetorTemp);
                    mostrarMensagem("perfil removido")
                    
                    handleCloseModal();
                    carregarPerfis();
                });
            // Fecha o modal e atualiza a lista imediatamente
            
            
       
    };

    return (
        <div className="dashboard">
            {/* Botão para abrir o modal */}
            <div style={{ marginBottom: "20px" }}>
                <PermissionGate permissions={["cadastrarPerfil"]}>
                    <Button variant="contained" color="primary" onClick={handleOpenModal}>
                        Cadastrar Perfil
                    </Button>
                </PermissionGate>
            </div>

            {/* Modal de Cadastro */}
            <Modal
                open={openModal}
                onClose={handleCloseModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={modalStyle}>
                    <PermissionGate permissions={["cadastrarPerfil"]}>
                        <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ mb: 2 }}>
                            Cadastrar Novo Perfil
                        </Typography>
                    </PermissionGate>
                    <TextField
                        fullWidth
                        label="Nome do Perfil"
                        name="nome"
                        value={modalPerfil.nome}
                        onChange={handleModalChange}
                        variant="outlined"
                        sx={{ mb: 3 }}
                        required
                    />
                    <Typography variant="subtitle1" sx={{ mb: 2 }}>Permissões:</Typography>

                    {Object.keys(permissoesPorCategoria).length > 0 ? (
                        <Box sx={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
                            gap: 2
                        }}>
                            {Object.entries(permissoesPorCategoria).map(([categoria, permissoes]) => (
                                <Box key={categoria} sx={{
                                    border: '1px solid #e0e0e0',
                                    borderRadius: '8px',
                                    p: 2
                                }}>
                                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>{categoria}</Typography>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 1 }}>
                                        {permissoes.map((permissao) => (
                                            <FormControlLabel
                                                key={permissao.nome}
                                                control={
                                                    <Checkbox
                                                        value={permissao.nome}
                                                        checked={modalPerfil.permissoes[permissao.nome] || false}
                                                        onChange={handleModalPermissaoChange(permissao.nome)}
                                                    />
                                                }
                                                label={permissao.descricao}
                                            />
                                        ))}


                                    </Box>
                                </Box>
                            ))}

                        </Box>
                    ) : (
                        <Typography>Nenhuma permissão disponível</Typography>
                    )}

                    <CadastrarPerfilFormulario
                        salvarPerfilModal={salvarPerfilModal}
                        alterarPerfilModal={alterarPerfilModal}
                        removerPerfilModal={removerPerfilModal}
                        modoEdicao={modalPerfil.id !== 0}
                        erro={error}
                    />

                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 3 }}>
                        <Button
                            variant="outlined"
                            onClick={handleCloseModal}
                            disabled={loading.salvando}
                        >
                            Cancelar
                        </Button>
                    </Box>
                </Box>
            </Modal>



            <CadastrarPerfilTabela
                vetor={perfis}
                editar={editar}
            />

            {/* Lista de perfis existentes (opcional) */}
            {/* ... seu código existente para listar perfis ... */}

            <Snackbar
                open={snackbarOpen}
                autoHideDuration={3000}
                onClose={() => setSnackbarOpen(false)}
                message={popperMessage}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            />
        </div>
    );
};

export default CadastrarPerfil;